import * as React from 'react';

import * as styles from './JournalHighlightsSliderDesktop.css';
import { SwiperCarousel } from '../../../../../../packages/SwiperCarousel';

import type { SwiperProps } from 'swiper/react';

interface IJournalHighlightsSliderDesktopProps {
  children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>[];
}

const CARDS_GAP = 16;
/** Минимальная ширина карточки статьи – `.card` в JournalHighlights.css */
const CARD_MIN_WIDTH = 200;

/** Ширина карусели, в которую помещается cardsCount карточек не уже CARD_MIN_WIDTH */
function getCarouselWidthFor(cardsCount: number): number {
  return cardsCount * CARD_MIN_WIDTH + (cardsCount - 1) * CARDS_GAP;
}

/**
 * Карточек на экране столько, сколько помещается по ширине карусели.
 * Меньше двух не бывает: на телефонах вместо карусели JournalHighlightsSliderMobile.
 */
const BREAKPOINTS: SwiperProps['breakpoints'] = {
  0: { slidesPerView: 2, slidesPerGroup: 2 },
  [getCarouselWidthFor(3)]: { slidesPerView: 3, slidesPerGroup: 3 },
  [getCarouselWidthFor(4)]: { slidesPerView: 4, slidesPerGroup: 4 },
  [getCarouselWidthFor(5)]: { slidesPerView: 5, slidesPerGroup: 5 },
};

export function JournalHighlightsSliderDesktop({ children }: IJournalHighlightsSliderDesktopProps) {
  return (
    <div className={styles['wrapper']}>
      <SwiperCarousel
        spaceBetween={CARDS_GAP}
        // До инициализации Swiper, в том числе на сервере, breakpoints не действуют
        slidesPerView={5}
        slidesPerGroup={5}
        breakpointsBase="container"
        breakpoints={BREAKPOINTS}
        allowTouchMove={false}
        className="journal-highlights-carousel"
        testId="JournalHighlightsCarousel"
      >
        {children}
      </SwiperCarousel>
    </div>
  );
}
